import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
import { CookieService } from 'ngx-cookie-service';

declare var jQuery: any;

@Component({
	selector: 'app-waz-videos',
	templateUrl: './waz-videos.component.html',
	styleUrls: ['./waz-videos.component.css']
})
export class WazVideosComponent implements OnInit {

	surveyCommentList: any;
	pager: any = {};
	pagedItems: any[];
	UservideoList: any[];
	total: any;
	limit: any;
	pageNo: any;
	base64textString: any;
	attached_image: any;
	flashMsg: string;
	selectedSurveyData: any;
	selectedSurveyId: any;
	surveyTypeList: any;
	surveyExpiryList: any;
	surveyCategoryList: any;
	url: any;
	surveyType: any;
	isDeleteSurvey: boolean;
	deleteSelectedSurveyData: any;
	searchStr: any = "";
	surveyCategory: any = "";
	surveyStatus: any = "";
	isSurveyAvailable: boolean = false;
	redirectUrl: any;
	activePageNo: number = 0;
	survey_question: any;
	survey_comment: any;

	constructor(
		private commonService: CommonService,
		private authServicess: AuthService,
		private pagerService: PagerService,
	) { }

	ngOnInit() {
		this.initialiseSurvey();
		this.commonService.process();
		$(".navbar-brand").text("Waz Videos");

	}

	// Get Survey List
	initialiseSurvey = function () {

		this.commonService.setTitle();
		this.limit = 10;
		this.pageNo = 1;
		this.url = '';
		this.surveyStatus = 0;

		// Get survey list
		this.getSurveyList(this.pageNo, this.limit);

	
	}
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	// Get vidoe list
	getSurveyList = function (pageNo, limit) {
	
		this.commonService.process();
		var requestObject = {
				"page" : pageNo,
				"num_records":limit
		}
		this.authServicess.getWazVideWazQuestions(requestObject).subscribe(data => {
			if (data.success) {
				this.isSurveyAvailable = false;
				this.surveyCommentList = data.data.question;
				this.total = data.data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			} else {

				this.surveyCommentList = [];
				this.isSurveyAvailable = true;
			}

			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		//$('.pages').removeClass('active')
		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
	
		if (!param) {
			this.getSurveyList(page, this.limit);
		}
	}

	// Update survey status .


	PlaySelectedUservideo = function (video) {

		var res = video.video.substring(0, 4);

		if (res.toLocaleUpperCase() == 'HTTP') {
			this.UservideoList = [video.video];
		} else {
			this.UservideoList = [this.commonService.videoUrl + video.video];
		}

	}


}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/waz-videos/waz-videos.component.ts